import { DiffPurchaseTypeClass, MgCreditNoteType, MgDebitNoteType, MGInvoiceTypeClass, MgOrderTypeClass, MgPurchaseTypeClass } from "./InvoiceTypeClass";
import { directFrontend, kooiFrontendSettings, provisionFrontend, purchaseFrontend, stockFrontend } from "./KooiFrontendClass";

export class MgFrontendSettings extends kooiFrontendSettings{
    name = "MgFrontendSettings";
    warn_missing_vat = false;
        invoices = {
            order: new MgOrderTypeClass(),
            customs: new MgOrderTypeClass(),
            Invoice: new MGInvoiceTypeClass(),
            proforma: new MGInvoiceTypeClass(),
            credit_note : new MgCreditNoteType(),
            debit_note : new MgDebitNoteType(),
        }
}

export class MgStockFrontendSettings extends stockFrontend{
    name = "MgStockfrontendSettings";
    warn_missing_vat = false;
        invoices = {
            order: new MgOrderTypeClass(),
            customs: new MgOrderTypeClass(),
            Invoice : new MGInvoiceTypeClass(),
            proforma: new MGInvoiceTypeClass(),
            debit_note : new MgDebitNoteType(),
            credit_note : new MgCreditNoteType(),
            purchase_contract : new MgPurchaseTypeClass(),
        }
}

export class MgPurchaseFrontendSettings extends purchaseFrontend{
    name = "MgPurchaseFrontendSettings";
    warn_missing_vat = false;
        invoices = {
            order: new MgOrderTypeClass(),
            customs: new MgOrderTypeClass(),
            Invoice : new MGInvoiceTypeClass(),
            proforma: new MGInvoiceTypeClass(),
            debit_note : new MgDebitNoteType(),
            credit_note : new MgCreditNoteType(),
            purchase_contract : new MgPurchaseTypeClass(),
            diff_purchase_contract : new DiffPurchaseTypeClass(),
        };
}

export class MgDirectFrontendSettings extends directFrontend{
    name = "MgDirectFrontendSettings";
    warn_missing_vat = false;
        invoices = {
            order: new MgOrderTypeClass(),
            customs: new MgOrderTypeClass(),
            Invoice: new MGInvoiceTypeClass(),
            proforma: new MGInvoiceTypeClass(),
            debit_note : new MgDebitNoteType(),
            credit_note : new MgCreditNoteType(),
            purchase_contract : new MgPurchaseTypeClass(),
        }
}


export class MgProvisionFrontendSettings extends provisionFrontend{
    name = "MgProvisionFrontendSettings";
    warn_missing_vat = false;
}
